import { Box, Flex, Collapse, ScaleFade } from "@chakra-ui/react";
import { Search } from "./Search";
import SharedDocsOwnerFilter from "./SharedDocsOwnerFilter";
import { IoMdAddCircle } from "react-icons/io";
import { CreateSharedDoc } from "./CreateSharedDoc";
import { SharedDocsList } from "./SharedDocsList";
import { EmptyTable } from "./EmptyTable";
import React from "react";
import LaunchdeckButton from "../../global/components/helper-components/components/LaunchdeckButton";

export const DisplayFullState = ({
  dsrId,
  altPageName,
  sharedDocsArray,
  searchTextInput,
  clearSearch,
  onSearchChange,
  handleSearch,
  isMobileView,
  showAddDocumentForm,
  handleFilterOwner,
  handleSharedDocOrderChange,
  dsrTeamMembers,
  setShowAddDocumentForm,
  showDeleteSpinner,
  handleDeleteSharedDoc,
  setShowDeleteSpinner,
  showPopoverDocId,
  setShowPopoverDocId,
  isOpen,
  onOpen,
  onClose,
  displaySignupPrompt,
  handleOpenSignupOrLoginModal,
  handleEditSharedDoc,
  isDsrAdmin,
  isRoomTemplate,
  isPagePreviewMode,
  handleShowPreviewPrompt
}) => {
  const isValidSharedDocsArrayAndNotEmpty = Array.isArray(sharedDocsArray) && sharedDocsArray?.length > 0;
  const handleClickAddDocumentButton = () => {
    displaySignupPrompt
      ? handleOpenSignupOrLoginModal()
      : isPagePreviewMode ?
        handleShowPreviewPrompt()
        : setShowAddDocumentForm(!showAddDocumentForm)
  }

  return (
    <Box w='100%'>
      <Flex justify="space-between" align="center">
        <Box>
          <Box
            color="brandDark.500"
            fontSize="1.5em"
            lineHeight="1.4em"
            fontWeight="600"
          >
            {altPageName || "Shared Documents"}
          </Box>
        </Box>
      </Flex>

      {showAddDocumentForm ?
        <Flex opacity={"1.0"} w='100%'>

          <Collapse in={true} animateOpacity style={{ width: "100%" }}>
            <CreateSharedDoc
              dsrId={dsrId}
              isMobileView={isMobileView}
              setShowAddDocumentForm={setShowAddDocumentForm}
              showAddDocummentForm={showAddDocumentForm}
            />
          </Collapse>
        </Flex>

        :
        <>
          <Flex w="100%" direction={["column", "row"]} align='center' mt="2em" mb='1.5em' gap={12}>
            <Box flex={[undefined, '8']}>
              <Search
                searchTextInput={searchTextInput}
                clearSearch={clearSearch}
                onSearchChange={onSearchChange}
                handleSearch={handleSearch}
              />
            </Box>

            <Flex
              direction={isMobileView && "column"}
              flex={[undefined, '1']}
              w="100%"
              align="center"
              justify="center"
              display={showAddDocumentForm ? "none" : "block"}
            >
              {!isRoomTemplate &&
                <SharedDocsOwnerFilter
                  handleFilterOwner={handleFilterOwner}
                  dsrTeamMembers={dsrTeamMembers}
                  sharedDocs={sharedDocsArray}
                />
              }


            </Flex>
          </Flex>

          <ScaleFade initialScale={0.9} in={true}>
            {isValidSharedDocsArrayAndNotEmpty ? (
              <SharedDocsList
                isMobileView={isMobileView}
                isDsrAdmin={isDsrAdmin}
                sharedDocsArray={sharedDocsArray}
                showDeleteSpinner={showDeleteSpinner}
                showPopoverDocId={showPopoverDocId}
                setShowPopoverDocId={setShowPopoverDocId}
                handleSharedDocOrderChange={handleSharedDocOrderChange}
                handleDeleteSharedDoc={handleDeleteSharedDoc}
                setShowDeleteSpinner={setShowDeleteSpinner}
                isOpen={isOpen}
                onOpen={onOpen}
                onClose={onClose}
                handleEditSharedDoc={handleEditSharedDoc}

                handleClickAddDocumentButton={handleClickAddDocumentButton}
              />
            ) : (
              <EmptyTable
                searchTextInput={searchTextInput}
                clearSearch={clearSearch}
              />
            )}
          </ScaleFade>
        </>

      }


      {isMobileView &&
        <Flex m="1.5em 0" w='100%'>
          <LaunchdeckButton
            w='100%'
            bg='brand.500'
            color='white'
            py='0.2em'
            onClick={handleClickAddDocumentButton}
          >
            <Flex gap={4} justify='center'>
              <IoMdAddCircle font-size='1.5em' />
              New
            </Flex>
          </LaunchdeckButton>
        </Flex>
      }
    </Box>
  );
};
